import { CSSProperties } from 'react';

export const LANDING_CTA_GLOW_CLASS = 'landing-cta-glow';

export const accentGlowStyle = (accentColor: string): CSSProperties =>
  ({ '--landing-cta-glow': accentColor }) as CSSProperties;
